import { API_URL } from "../config/config";
import { APIResponse } from "../types/api.types";
import { APIQuery } from "./api.base";
import { isSuccessCode } from "../helpers/apiResponse";

export const DEVICE_UUID_STORAGE_KEY = "device_uuid";


export const registerDevice = async (): Promise<APIResponse> => {
    const response = await fetch(`${API_URL}/device/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({brand: navigator.userAgent || "unknown", type: "web" })
    });

    const data = await response.json();
    
    const resolvedUUID = data?.data?.uuid || data?.data?.device_uuid;
    return {
        request_id: data?.request_id ?? "",
        error_code: data?.error_code ?? "1.1.9.999", // ERROR CODE TO CORRECT
        speed: data?.speed ?? "0",
        data: {
            ...(data?.data ?? {}),
            uuid: resolvedUUID
        }
    };
};

export const verifyDevice = async (uuid: string): Promise<APIResponse> => {
    return APIQuery(`/device/verify/?uuid=${uuid}`, "GET", []);
};

export const getOrRegisterDevice = async (): Promise<string> => {
    const savedUUID = window.localStorage.getItem(DEVICE_UUID_STORAGE_KEY);

    if (savedUUID) {
        try {
            const verify = await verifyDevice(savedUUID);
            if (isSuccessCode(verify.error_code)) {
                if (!verify.data.registered) return await registerDevice().then(res => res.data.uuid);
                return savedUUID;
            }
        } catch (error) {
            console.debug("Device verification failed", error);
        }
    }

    const registered = await registerDevice();
    const uuid = registered.data?.uuid;
    if (!uuid) {
        throw new Error("Unable to register device");
    }

    window.localStorage.setItem(DEVICE_UUID_STORAGE_KEY, uuid);
    return uuid;
};
